export default __webpack_public_path__ + "static/media/user-dummy.0190eb15.png";